<i18n>
{
"en": {
  "IMPORTDATA": "Import Data",
  "IMPORT": "Import",
  "REQUIREDFIELDS": "Required fields",
  "SELECTFIELD": "Select field",
  "SELECTFIELDVALUE": "Select field value",
  "CANCEL": "Cancel",
  "IMPORTINGDATA": "Importing Data...",
  "STARTIMPORTING": "Start Importing",
  "SUCCESSFULLYIMPORTED": "Successfully imported",
  "FAILEDIMPORT": "Import is aborted, Please try again!",
  "DATA": "Data",
  "UPLOAD": "Upload",
  "CLOSE": "Close",
  "DATAFIELDTYPE": "Data Field Type",
  "DATAVALUE": "Data Value",
  "CSVCOLUMN": "CSV Column",
  "FORMAT": "Format",
  "N/A": "N/A",
  "SELECTFORMAT": "Select format"
},
"ar": {
  "IMPORTDATA": "استورد البيانات",
  "IMPORT": "استورد",
  "REQUIREDFIELDS": "المجالات المطلوبة",
  "SELECTFIELD": "حدد المجال",
  "SELECTFIELDVALUE": "حدد قيمة المجال",
  "CANCEL": "الغاء",
  "IMPORTINGDATA": "استيراد البيانات",
  "STARTIMPORTING": "بدء الاستيراد",
  "SUCCESSFULLYIMPORTED": "تم استيرادها بنجاح",
  "FAILEDIMPORT":"تم إحباط الاستيراد، يرجى المحاولة مرة أخرى! ",
  "DATA": "البيانات",
  "UPLOAD": "تحميل",
  "CLOSE": "أغلق",
  "DATAFIELDTYPE": "نوع مجال البيانات",
  "DATAVALUE": "قيمة البيانات",
  "CSVCOLUMN": "  CSV عمود ",
  "FORMAT": "شكل",
  "N/A": "غير قابل للتطبيق",
  "SELECTFORMAT": "تحديد الشكل"
}
}
</i18n>
<template>
    <el-dialog
    :title="$t('IMPORTDATA')"
    :close-on-click-modal="false"
    :show-close="false"
    :visible.sync="dialogVisible">
    <el-card id="import" class="box-card">
    <div slot="header" class="clearfix">
        <span style="line-height: 36px;text-transform:capitalize;">{{$t('IMPORT') + ' ' + title}}</span>
        <span style="line-height: 36px;float:right"><i  class="el-icon-warning text-danger"></i> {{$t('REQUIREDFIELDS')}}</span>
    </div>
    <el-row :gutter="20">
    <el-col :span="12">
    <el-select v-model="importField" value-key="field" :placeholder="$t('SELECTFIELD')">
        <el-option
        v-for="(item, key) in fields"
        v-if="isSet(item.field)"
        :label="item.label"
        :key="key"
        :value="item">
        {{item.label}} <i v-if="item.required" style="float:right" class="el-icon-warning text-danger"></i>
        </el-option>
    </el-select>
    </el-col>

    <el-col :span="12">
    <el-select v-model="importValue" :disabled="!importField"  @change="setValue" :placeholder="$t('SELECTFIELDVALUE')">
        <el-option
        v-if="isSet(key, true)"
        :key="key"
        v-for="(value, key) in csv_reader"
        :label="key + ':' + value"
        :value="key">
        </el-option>
    </el-select>
    </el-col>

    </el-row>

    <el-row style="margin:-10px; margin-top:10px;">
    <el-table
        :height="400"
        highlight-current-row
        stripe
        :data="importData"
        style="width: 100%">
        <el-table-column
            prop="name"
            min-width="120"
            :label="$t('DATAFIELDTYPE')"
        >
        </el-table-column>
        <el-table-column
            prop="value"
            min-width="130"
            :label="$t('DATAVALUE')"
            >
        </el-table-column>
                <el-table-column
            prop="csv_field"
            min-width="140"
            :label="$t('CSVCOLUMN')"
            >
        </el-table-column>

        <el-table-column
        :label="$t('FORMAT')"
        min-width="150"
        align="center"
        >
                <template slot-scope="scope">
                    <span v-if="!scope.row.format">{{$t('N/A')}}</span>
                    <el-select v-model="scope.row.format_value"  v-if="scope.row.format" :placeholder="$t('SELECTFORMAT')">
                        <el-option
                        :key="index" 
                        v-for="(item, index) in formats[scope.row.format]"
                        :label="item.value"
                        :value="item.format">
                        </el-option>
                    </el-select>
                </template>
        </el-table-column>

        <el-table-column align="right" width="50">
                <template slot-scope="scope">
                    <el-button type="text" @click="resetValue(scope.row.field)" icon="close"></el-button>
                </template>
        </el-table-column>
        </el-table>
    </el-row>
    <el-upload
      v-show="false"
      ref="upload"
      accept=".csv"
      class="upload-demo"
      :action="URL + 'media/import'"
      :headers="{'Accept-Language': currentLang()}"
      :on-success="uploadedFile">
    </el-upload>
    </el-card>
    <span slot="footer" class="dialog-footer">
        <el-button  @click="cancelImport">{{$t('CANCEL')}}</el-button>
        <el-button :disabled="required_fields!=0" type="primary" :loading="importing" @click="startImporting">{{importing ? $t('IMPORTINGDATA') : $t('STARTIMPORTING')}}</el-button>
    </span>
    </el-dialog>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'ElImportDialog',
  componentName: 'ElImportDialog',
  props: {
    fields: {
      type: Array,
      default: function () {
        return []
      }
    },
    CSVReader: {
      type: Object,
      required: true,
      default: function () {
        return {}
      }
    },
    CSVFile: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    uri: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dialogVisible () {
      this.$emit('update:visible', this.dialogVisible)
    },
    visible () {
      this.switchLanguage()
      this.dialogVisible = this.visible
      this.required_fields = this.fields.filter(function (obj) { return obj.required }).length
      this.csv_reader = _.clone(this.CSVReader)
      this.csv_file = this.CSVFile
    }
  },
  data () {
    return {
      dialogVisible: false,
      importing: false,
      importValue: null,
      importValues: {},
      registredFields: [],
      importedData: {},
      importData: [],
      importField: null,
      required_fields: null,
      csv_reader: null,
      csv_file: '',
      formats: {}
    }
  },
  mounted () {
    let date = this.$moment().set({'month': 12, 'date': 31})
    this.formats = {date: [
      {format: 'm-d-y', value: date.format('MM-DD-YY')},
      {format: 'm-d-Y', value: date.format('MM-DD-YYYY')},
      {format: 'd-m-y', value: date.format('DD-MM-YY')},
      {format: 'd-m-Y', value: date.format('DD-MM-YYYY')},
      {format: 'y-m-d', value: date.format('YY-MM-DD')},
      {format: 'Y-m-d', value: date.format('YYYY-MM-DD')},
      {format: 'y-d-m', value: date.format('YY-DD-MM')},
      {format: 'Y-d-m', value: date.format('YYYY-DD-MM')},
      {format: 'M-d-y', value: date.format('MMM-DD-YY')},
      {format: 'M-d-Y', value: date.format('MMM-DD-YYYY')},
      {format: 'j-M-y', value: date.format('DD-MMM-YY')},
      {format: 'j-M-Y', value: date.format('DD-MMM-YYYY')},
      {format: 'y-d-M', value: date.format('YY-DD-MMM')},
      {format: 'Y-d-M', value: date.format('YYYY-DD-MMM')}
    ]}
  },
  methods: {
    cancelImport () {
      this.dialogVisible = false
      this.csv_file = this.importField = this.importValue = null
      this.importValues = this.csv_reader = {}
      this.registredFields = this.importData = []
    },
    resetValue (key) {
      let item = this.importValues[key]
      if (item.required) this.required_fields++
      let index = this.registredFields.indexOf(item.csv_field)
      this.$delete(this.registredFields, index)
      this.$delete(this.importValues, key)
      this.importedFields()
    },
    isSet (key, value) {
      if (value === undefined) {
        if (this.importValues[key] === undefined) return true
        return false
      }
      if (this.registredFields.indexOf(key) < 0) return true
      return false
    },
    setValue (fill) {
      if (this.importField === null) return
      if (this.importField.required) this.required_fields--
      this.importValues[this.importField.field] = {field: this.importField.field, name: this.importField.label, format: this.importField.format, required: this.importField.required, format_value: 'd-m-Y', value: this.csv_reader[fill], csv_field: fill}
      this.registredFields.push(fill)
      this.importField = this.importValue = null
      this.importedFields()
    },
    importedFields () {
      let data = []
      for (let item in this.importValues) {
        data.push(this.importValues[item])
      }
      this.importData = data
    },
    startImporting () {
      this.importing = true
      if (Object.keys(this.importedData).length === 0) return this.import()
    },
    uploadedFile (response, file, fileList) {
      if (response.error) {
        return this.$message({
          message: response.error,
          type: 'error',
          showClose: true
        })
      }
      this.csv_reader = response.fields
      this.csv_file = response.file_name
    },
    import () {
      let self = this
      let postData = {cvs_file: self.csv_file, cvs_fields: self.importValues}
      this.$http.post('/' + self.uri, postData)
        .then(function (response) {
          self.cvs_file = self.importField = self.importValue = null
          self.importValues = self.csv_reader = {}
          self.registredFields = []
          self.importing = false
          self.$alert(self.$t('SUCCESSFULLYIMPORTED') + ' ' + self.title + ' ' + self.$t('DATA'), {
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: self.$t('CLOSE'),
            callback: action => {
              self.$emit('reCall', {})
              self.importData = []
              self.dialogVisible = false
            }
          })
        }).catch(function (error) {
          self.$alert(self.$t('FAILEDIMPORT'), {
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: self.$t('CLOSE'),
            callback: action => {
              self.importing = false
              self.cancelImport()
            }
          })
          console.log(error)
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Import.vue?57bf5606